// === wizardStepParticipant.js START =============================================================

wizardSteps["participants"] = {
    templateName: "#wizardStepParticipantsTemplate",
    onInit: function () {
        Handlebars.registerPartial("appointmentParticipants", $("#m-modal__participant-box-template").html());
        Handlebars.registerPartial("contactList", $("#m-modal__contact-list-template").html());
        Handlebars.registerPartial("seriesSelector", $("#m-modal__series-selector-template").html());
    },
    participants: [],
    beforeRender: function (ctx) {
        if (!currentEvent.maxParticipants) {
            // Single trainings can only have one participant
            currentEvent.maxParticipants = currentEvent.appointmentType === "SingleTraining" ? 1 : 5;
        }
        ctx.model.maxParticipants = currentEvent.maxParticipants;

        ctx.model.participants = wizardSteps["participants"].participants = (ctx.model.o.participants || []).slice(0);

        ctx.model.contactsLoading = true;

        if (typeof contactList === "undefined") {
            contactList = [];
        }
        ctx.model.messages = {
            selectParticipant: $t("Select participant"),
            maximumParticipants: $t("Maximum participants"),
            addressBook: $t("Addressbook"),
            addExternalParticipant: $t("Add external participant"),
            validDataPlease: $t("Please provide complete and validate data (phone number is optional)"),
            noParticipant: $t("No participant selected yet"),
            willLoad: $t("Your contact list will be loaded"),
            add: $t("Add"),
            noContacts: $t("Your contact list is empty."),
            paymentStatusUnpaid: $t('Unpaid'),
            paymentStatusFree: $t('Free'),
            paymentStatusPaidCash: $t('PaidCash')
        };

        ctx.model.paymentTransitions = PaymentStatusTransitions.map(function(s) {
            return {
                key: s.key,
                value: $t(s.value)
            };
        });
    },
    afterRender: function (ctx) {
        // Load contact list
        if (contactList.length !== 0) {
            // Already present
            ctx.model.contactList = contactList;
            wizardSteps["participants"].prepFilteredList(ctx);
            wizardSteps["participants"].rebuildContactList(ctx);
            wizardSteps["participants"].rebuildParticipantList(ctx);
        }

        // But try to reload the contacts in case something changed.
        ApiClient.getContactList(currentEvent.locationId)
            .done(function(data) {
                for (var i = 0; i < data.data.length; i++) {
                    // This is used for accessing array data in addParticipant method
                    // Mustache provides @index in loops, but that would go wrong during filtering
                    data.data[i].internalIndex = i;
                }
                // This variable is used for filtering and updating whenever needed
                contactList = data.data;
                // This is make Handlebars display it's content
                ctx.model.contactList = contactList;

                wizardSteps["participants"].prepFilteredList(ctx);
                wizardSteps["participants"].rebuildContactList(ctx);
                wizardSteps["participants"].rebuildParticipantList(ctx);

                // Resize the iframe and reposition the modal.
                window.performResize();
                window.PositionModal();
            })
            .fail(function(msg) {
                ShowErrorPanel(msg.error);
            })
            .always(function() {
                ctx.model.contactsLoading = false;
            });

        // Filter
        $("#m-modal__input-address-filter").on("keyup", function () {
            wizardSteps["participants"].prepFilteredList(ctx);
            wizardSteps["participants"].rebuildContactList(ctx);
        });

        // External participants
        $("#m-modal__btn-add-external-participant").click(function () {
            var $firstNameField = $("#m-modal__input--external-participant-firstname");
            var firstName = ($firstNameField.val() || "").trim();
            var $lastNameField = $("#m-modal__input--external-participant-lastname");
            var lastName = ($lastNameField.val() || "").trim();
            var $emailField = $("#m-modal__input--external-participant-email");
            var email = $emailField.val();
            var validationError = $(".m-modal__validation-error--external-participant");

            if (!firstName || !lastName || (
                email && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
            )) {
                validationError.show();
                return;
            }
            validationError.hide();

            var $phoneField = $("#m-modal__input--external-participant-phone");
            var phone = $phoneField.val();

            wizardSteps["participants"].participants.push({
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
                isExternal: true,
                paymentStatus: 'Unpaid',
                canChangePaymentState: true,
                showPaymentStatusDate: false
            });
            wizardSteps["participants"].rebuildParticipantList(ctx);

            $firstNameField.val("");
            $lastNameField.val("");
            $emailField.val("");
            $phoneField.val("");
        });
    },
    prepFilteredList: function (ctx) {
        var search = $("#m-modal__input-address-filter").val().trim();

        var alreadyParticipating = [];
        for (var o = 0; o < wizardSteps["participants"].participants.length; o++) {
            var uid = wizardSteps["participants"].participants[o].userId;
            if (typeof uid === "undefined")
                continue;
            alreadyParticipating.push(uid);
        }

        var replacementList = [];
        for (var i = 0; i < contactList.length; i++) {
            var contact = contactList[i];

            // Search active?
            if (search !== ""
                && !contact.firstName.containsIgnoreCase(search)
                && !contact.lastName.containsIgnoreCase(search)) {
                continue;
            }

            // Already a participant?
            // All users in the contact list have a userId defined. External users don't.
            if (typeof contact.userId !== "undefined"
                && alreadyParticipating.indexOf(contact.userId) !== -1) {
                continue;
            }

            replacementList.push(contact);
        }

        ctx.model.filteredContactList = replacementList;
    },
    rebuildContactList: function (ctx) {
        var template = Handlebars.partials["contactList"];
        var $wrapper = $("#m-modal__select-participants-wrapper");
        $wrapper.html(template(ctx.model));
        $wrapper.find("li").click(function () {
            var $option = $(this);
            var participantToAdd = contactList[$option.data("value")];
            participantToAdd.paymentStatus = 'Unpaid';
            participantToAdd.canChangePaymentState = true;
            participantToAdd.showPaymentStatusDate = false;
            participantToAdd.canSelectPrepaidCard = participantToAdd.prepaidBalance >= currentEvent.price;
            wizardSteps["participants"].participants.push(participantToAdd);

            wizardSteps["participants"].prepFilteredList(ctx);
            wizardSteps["participants"].rebuildContactList(ctx);
            wizardSteps["participants"].rebuildParticipantList(ctx);
        });
    },
    rebuildParticipantList: function (ctx) {
        if (wizardSteps["participants"].participants.length) {
            for (var k in wizardSteps["participants"].participants) {
                if (!wizardSteps["participants"].participants.hasOwnProperty(k)) {
                    continue;
                }
                var p = wizardSteps["participants"].participants[k];
                p.paymentStatusTranslation = $t(p.paymentStatus);

                if (!!p.paymentStatusDate) {
                    p.showPaymentStatusDate = true;
                } else {
                    p.showPaymentStatusDate = false;
                }

                if (!p.userId) continue;

                for (var i = 0; i < contactList.length; i++) {
                    if (contactList[i].userId === p.userId) {
                        p.canSelectPrepaidCard = contactList[i].prepaidBalance >= currentEvent.price;
                        break;
                    }
                }
            }
        }

        var template = Handlebars.partials["appointmentParticipants"];
        var $wrapper = $(".m-modal__participants-display");
        $wrapper.html(template(ctx.model));
        // TODO Why does the bind event not work the first time if the console messages are removed?
        var $btns = $wrapper.find(".m-modal__icon--participant-remove");
        console.info("Bound event to " + $btns.length + " trash can buttons");
        $btns.click(function () {
            var $part = $(this).parents(".m-modal__participant-box");
            var index = $part.data("index");
            console.info("Removed entry " + index + " from participant list");
            wizardSteps["participants"].participants.splice(index, 1);

            wizardSteps["participants"].prepFilteredList(ctx);
            wizardSteps["participants"].rebuildContactList(ctx);
            wizardSteps["participants"].rebuildParticipantList(ctx);
        });

        var $changeStatus = $wrapper.find('.m-modal__participant-box__updatePaymentStatus');
        if ($changeStatus.length) {
            // Select the current payment status.
            $changeStatus.each(function() {
                var $this = $(this);
                var index = $this.parents('.m-modal__participant-box').first().data('index');
                $this.val(PaymentStatus[wizardSteps['participants'].participants[index].paymentStatus]);
            });

            // Create on change event.
            $changeStatus.on('change',
                function() {
                    var $this = $(this);

                    var index = $this.parents('.m-modal__participant-box').first().data('index');
                    wizardSteps['participants'].participants[index].paymentStatus =
                        PaymentStatus[parseInt($this.val())];
                    if (wizardSteps['participants'].participants[index].paymentStatus === "Transfer" ||
                        wizardSteps['participants'].participants[index].paymentStatus === "Cancellation" ||
                        wizardSteps['participants'].participants[index].paymentStatus === "PaidCashDone") {
                        if (!wizardSteps['participants'].participants[index].paymentStatusDate) {
                            wizardSteps['participants'].participants[index].paymentStatusDate = currentEvent.start.format('L');
                        }
                        wizardSteps['participants'].participants[index].showPaymentStatusDate = true;
                    } else {
                        wizardSteps['participants'].participants[index].showPaymentStatusDate = false;
                        wizardSteps['participants'].participants[index].paymentStatusDate = undefined;
                    }
                    wizardSteps["participants"].rebuildParticipantList(ctx);
                });
        }

        var $dateSelection = $(".m-modal__payment-status-date-selection");
        if ($dateSelection.length) {
            $dateSelection.each(function () {
                var $this = $(this);
                var index = $this.parents('.m-modal__participant-box').first().data('index');
                var selectedDate = wizardSteps['participants'].participants[index].paymentStatusDate;
                $this.datepicker({
                    dateFormat: dateTimeFormatString.dateFormatPicker
                }).val(selectedDate !== undefined ? selectedDate : currentEvent.start.format('L'));
            });

            $dateSelection.on('change',
                function () {
                    var $this = $(this);

                    var index = $this.parents('.m-modal__participant-box').first().data('index');
                    wizardSteps['participants'].participants[index].paymentStatusDate =
                        moment($this.datepicker("getDate")).format('L');
                });
        }

        if (currentEvent.appointmentType === "SingleTraining") {

            if (currentEvent.participants && currentEvent.participants.length <= currentEvent.maxParticipants) {

                var $inputParticipant = $('#m-modal__input-participants-count');
                if ($inputParticipant.length) {
                    $inputParticipant.removeClass('error');
                }

                var $participantsBox = $('.m-modal__participant-box');
                if ($participantsBox.length) {
                    $participantsBox.removeClass('m-modal__error-border');
                }
            }
        }
        wizardSteps["participants"].refreshParticipantWarning();
    },
    refreshParticipantWarning: function () {
        // Max participants warning
        var attentionIcon = $(".m-modal__icon--participants-attention");

        var inputParticipant = $('#m-modal__input-participants-count');

        if (currentEvent.participants && currentEvent.participants.length > currentEvent.maxParticipants) {
            attentionIcon.show();
            inputParticipant.addClass('error');
        } else {
            attentionIcon.hide();
            inputParticipant.removeClass('error');
        }
    },
    save: function () {
        currentEvent.participants = wizardSteps["participants"].participants;
    },
    getButtonList: function () {
        return {
            "back": true,
            "advertise": currentEvent.appointmentType !== "SingleTraining" && currentEvent.appointmentType !== "Absence",
            "series": currentEvent.appointmentType !== "Package" & !currentEvent.appointmentId,
            "save": true
        };
    }
};

// === wizardStepParticipant.js END ===============================================================
